import type { ContactInfo, TeamMember, TeamMemberWContact } from "@repo/types";
import { contactInfoRepo } from "./contactInfoRepo";

export const teamMemberRepo = {
  init: (teamMember?: Partial<TeamMember>): TeamMember => {
    return {
      title: "",
      userId: "",
      role: "submit",
      class: "voting",
      expires: false,
      ...teamMember,
    };
  },

  initWithContactInfo: (
    member?: Partial<TeamMember>,
    contactInfo?: Partial<ContactInfo>
  ): TeamMemberWContact => {
    return {
      ...teamMemberRepo.init(member),
      contactInfo: contactInfoRepo.init(contactInfo),
    };
  },
};
